import React, {Component} from "react";
import {AgGridReact} from "ag-grid-react";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-balham.css';
import 'ag-grid-community/dist/styles/ag-theme-material.css';
import 'ag-grid-community/dist/styles/ag-theme-bootstrap.css';
import {userActions} from "../../authentication/_actions";
import apiClient from "api/client";
import {Col, Grid, Row} from "react-bootstrap";

class FeatureItemOrderingForMenu extends Component {
    constructor(props) {
        super(props);

        this.state = {
            columnDefs: [
                // Drag handle (recommended) so users don't accidentally drag when editing
                {
                    headerName: "",
                    width: 50,
                    rowDrag: true,
                    sortable: false,
                    filter: false,
                    suppressMenu: true,
                    pinned: 'left',
                    lockPosition: true,
                    cellClass: 'ag-row-drag',
                },
                {
                    width: 80,
                    field: "feature_id",
                },
                {
                    width: 70,
                    field: "position",
                    editable: true,
                },
                {field: "asset_name"},
                {
                    headerName: "Actions",
                    width: 120,
                    sortable: false,
                    filter: false,
                    suppressMenu: true,
                    editable: false,
                    cellRendererFramework: params => this.renderRemoveButton(params),
                },
            ],
            defaultColDef: {
                // width: 150,
                sortable: false,
                filter: false
            },
            rowData: [],

            channels: [],
            loading: false,
            dirty: false,
            saving: false,
            removingId: null
        };
    }

    componentDidMount() {
        this.loadData();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log(prevProps);
        if (
            this.props.menuId !== prevProps.menuId ||
            this.props.applicationId !== prevProps.applicationId
        ) {
            this.loadData();
        }
    }

    loadData() {

        let menuId = this.props.menuId
        let applicationId = this.props.applicationId

        if (menuId && applicationId) {
            this.setState({loading: true});
            let user = JSON.parse(localStorage.getItem('user'));
            let token = ""

            if (user) {
                token = user.token
            } else {
                this.props.dispatch(userActions.logoutUnauthorized());
            }

            let axiosConfig = {
                headers: {'X-Id-Token': token}
            };


            let dataUrl = process.env.REACT_APP_API_URL + "/ApplicationsManagement/" + applicationId + "/device-menu/" + menuId + "/feature-menu-ordering";

            apiClient.get(dataUrl, axiosConfig).then(response => {
                const channels = Array.isArray(response.data) ? response.data : [];
                const loading = false;
                this.setState({
                    channels,
                    loading,
                    dirty: false,
                    saving: false,
                    removingId: null
                }, () => this.syncGridData());
            }).catch(error => {
                this.setState({
                    channels: [],
                    loading: false,
                    dirty: false,
                    saving: false,
                    removingId: null
                });
                //this.props.dispatch(userActions.logoutUnauthorized());
                console.log(error);
            });

        }


    }

    getAxiosConfig(includeJson = false) {
        let user = JSON.parse(localStorage.getItem('user'));
        let token = "";

        if (user) token = user.token;
        else this.props.dispatch(userActions.logoutUnauthorized());

        let headers = {'X-Id-Token': token};

        if (includeJson) {
            headers['Content-Type'] = 'application/json';
        }

        return {headers};
    }

    syncGridData() {
        if (this.gridApi) {
            this.gridApi.setRowData(this.state.channels || []);
            this.gridApi.refreshCells({force: true});
        }
    }

    getCurrentGridOrder() {
        const ordered = [];
        if (this.gridApi) {
            this.gridApi.forEachNodeAfterFilterAndSort((node) => {
                if (node && node.data) ordered.push(node.data);
            });
        } else {
            ordered.push(...(this.state.channels || []));
        }
        return ordered.map((row, idx) => ({...row, position: idx}));
    }

    markDirtyAndSyncGrid(ordered) {
        this.setState({channels: ordered, dirty: true}, () => {
            this.syncGridData();
        });
    }

    saveOrder() {
        const menuId = this.props.menuId;
        const applicationId = this.props.applicationId;
        if (!menuId || !applicationId) return;

        const ordered = this.getCurrentGridOrder();
        let axiosConfig = this.getAxiosConfig(true);

        const url = process.env.REACT_APP_API_URL + "/ApplicationsManagement/" + applicationId + "/device-menu/" + menuId + "/feature-menu-ordering";
        const payload = {items: ordered.map(r => ({id: r.id, feature_id: r.feature_id, position: r.position}))};

        this.setState({saving: true});
        apiClient.put(url, payload, axiosConfig)
            .then(() => {
                this.setState({saving: false, dirty: false});
                this.loadData();
            })
            .catch((error) => {
                console.log(error);
                this.setState({saving: false});
            });
    }

    removeItemFromMenu(rowData) {
        const menuId = this.props.menuId;
        const applicationId = this.props.applicationId;
        const pivotId = rowData && rowData.id ? rowData.id : null;

        if (!menuId || !applicationId || !pivotId) return;
        if (this.state.dirty || this.state.saving || this.state.loading || this.state.removingId !== null) return;

        const itemName = rowData.asset_name ? '"' + rowData.asset_name + '"' : 'this feature item';
        const shouldRemove = window.confirm("Remove " + itemName + " from this menu?");

        if (!shouldRemove) return;

        const url = process.env.REACT_APP_API_URL + "/ApplicationsManagement/" + applicationId + "/device-menu/" + menuId + "/feature-menu-ordering/" + pivotId;

        this.setState({removingId: pivotId}, () => this.syncGridData());

        apiClient.delete(url, this.getAxiosConfig())
            .then(() => {
                this.loadData();
            })
            .catch((error) => {
                console.log(error);
                this.setState({removingId: null}, () => this.syncGridData());
            });
    }

    renderRemoveButton(params) {
        const rowData = params && params.data ? params.data : null;
        if (!rowData) return null;

        const isRemovingThisRow = this.state.removingId === rowData.id;
        const isBusyRemoving = this.state.removingId !== null;
        const disabled = this.state.dirty || this.state.saving || this.state.loading || isBusyRemoving;
        const title = this.state.dirty
            ? "Save ordering before removing items."
            : "Remove from this menu";

        return (
            <button
                type="button"
                className="btn btn-danger btn-fill btn-xs"
                disabled={disabled}
                title={title}
                onClick={() => this.removeItemFromMenu(rowData)}
            >
                {isRemovingThisRow ? "Removing..." : "Remove"}
            </button>
        );
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    onRowDragEnter(e) {
        //console.log("onRowDragEnter", e);
    }

    onRowDragEnd(e) {
        const ordered = this.getCurrentGridOrder();
        this.markDirtyAndSyncGrid(ordered);
    }

    onRowDragMove(e) {
        //console.log("onRowDragMove", e);
    }

    onRowDragLeave(e) {
        //console.log("onRowDragLeave", e);
    }

    onCellEdit(e) {
        if (!e || !e.data) return;
        if (e.colDef && e.colDef.field === 'position') {
            const newPosRaw = Number(e.newValue);
            if (!Number.isFinite(newPosRaw)) return;
            const newPos = Math.max(0, Math.min((this.state.channels?.length || 1) - 1, Math.floor(newPosRaw)));
            const curr = [...(this.state.channels || [])];
            const idx = curr.findIndex(r => r.id === e.data.id);
            if (idx === -1) return;
            const [moved] = curr.splice(idx, 1);
            curr.splice(newPos, 0, moved);
            const normalized = curr.map((r, i) => ({...r, position: i}));
            this.markDirtyAndSyncGrid(normalized);
        }
    }

    render() {
        return (
            <Row>
                <Col md={12}>
                    {/*<Card*/}
                    {/*    title={"Feature item order in category " +*/}
                    {/*        "(Double click position to changed it)"}*/}
                    {/*    category={"Reorder locally, then click Save to submit"}*/}
                    {/*    content={*/}
                    {/*        <div>*/}
                    {/*            <legend></legend>*/}
                                <Grid fluid>
                                    <Row>
                                        <Col md={12}>
                                            {/*<div style={{width: "100%", height: "100%"}}>*/}
                                            {this.state.loading ? (
                                                <div className="text-center" style={{padding: "40px 0"}}>
                                                    <i className="fa fa-spinner fa-spin"/> Loading...
                                                </div>
                                            ) : (this.state.channels && this.state.channels.length > 0) ? (
                                                <div>
                                                    <div className="clearfix" style={{marginBottom: "10px"}}>
                                                        <button
                                                            className="btn btn-success btn-fill pull-right"
                                                            disabled={!this.state.dirty || this.state.saving}
                                                            onClick={() => this.saveOrder()}
                                                        >
                                                            {this.state.saving ? "Saving..." : "Save ordering"}
                                                        </button>
                                                        <div className="text-muted" style={{paddingTop: "8px"}}>
                                                            Drag rows or edit the <b>position</b> column. Changes are
                                                            kept locally until you save. Remove detaches the feature
                                                            from this menu only.
                                                        </div>
                                                    </div>
                                                    <div
                                                        id="myGrid"
                                                        style={{
                                                            height: "609px",
                                                            width: "100%"
                                                        }}
                                                        className="ag-theme-balham"
                                                    >
                                                        <AgGridReact
                                                            columnDefs={this.state.columnDefs}
                                                            defaultColDef={this.state.defaultColDef}
                                                            rowDragManaged={true}
                                                            animateRows={true}
                                                            suppressMoveWhenRowDragging={true}
                                                            onGridReady={this.onGridReady}
                                                            rowData={this.state.channels}
                                                            onRowDragEnter={this.onRowDragEnter.bind(this)}
                                                            onRowDragEnd={this.onRowDragEnd.bind(this)}
                                                            onRowDragMove={this.onRowDragMove.bind(this)}
                                                            onRowDragLeave={this.onRowDragLeave.bind(this)}
                                                            onCellValueChanged={this.onCellEdit.bind(this)}
                                                        />
                                                    </div>
                                                    {/*</div>*/}
                                                </div>
                                            ) : (
                                                <div className="text-muted" style={{padding: "20px"}}>
                                                    No feature items found for this menu.
                                                </div>
                                            )}
                                        </Col>
                                    </Row>
                                </Grid>
                            {/*</div>*/}
                    {/*    }*/}
                    {/*/>*/}
                </Col>
            </Row>
        );
    }
}


function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedLiveFeatureItemOrderingForMenu = connect(mapStateToProps)(FeatureItemOrderingForMenu);
const connectedLiveFeatureItemOrderingForMenuTrans = withNamespaces('common')(connectedLiveFeatureItemOrderingForMenu);
export {connectedLiveFeatureItemOrderingForMenuTrans as FeatureItemOrderingForMenu};
